
import ReactPaginate from 'react-paginate';
import { ArrowRight2 } from 'components/icons';
import { PaginationWrapper } from './styles/pagination.styles';
import { PaginationProps } from './type';
import { useNavigate, useLocation } from 'react-router-dom';

const Pagination = ({ data, setPageNumber, loading = false, isStore = false }: PaginationProps) => {
  const navigate = useNavigate();
  const location = useLocation();

  const handlePageClick = ({ selected }: { selected: number }) => {
    setPageNumber(selected);
    const params = new URLSearchParams(location.search);
    params.set('page', (selected + 1).toString());
    navigate({ search: params.toString() });
  };

  // Get current page from query param, default to 1
  const params = new URLSearchParams(location.search);
  const currentPage = parseInt(params.get('page') || '1', 10);

  return (
    <><PaginationWrapper isStore={isStore}>
      <ReactPaginate
        breakLabel="..."
        nextLabel={<ArrowRight2 />}
        onPageChange={handlePageClick}
        pageRangeDisplayed={3}
        marginPagesDisplayed={1}
        pageCount={data?.totalPageCount ?? 1}
        forcePage={currentPage - 1}
        previousLabel={<ArrowRight2 />}
        containerClassName={'paginate'}
        pageClassName={'page-item'}
        pageLinkClassName={'page-link'}
        activeClassName={'active-page'}
        nextLinkClassName={'next-btn'}
        previousLinkClassName={'previous-btn'}
        disabledClassName={'pagination-disabled'}
      />
    </PaginationWrapper>

    </>
  );
};

export default Pagination;